<h2 data-testid="SUBSYS5_NOTIFICATION_THRESHOLD_TITLE_TXT" class="text-uppercase">
	{{ labels().NOTIFICATION_THRESHOLD_COMPONENT_TITLE }}
</h2>

<div class="d-flex mt-5">
	<div class="flex-shrink-0">
		<form>
			<div class="form-group pb-0">
				<label data-testid="SUBSYS5_NOTIFICATION_THRESHOLD_VALUE_LBL" for="notification-threshold">
					{{ labels().NOTIFICATION_THRESHOLD_COMPONENT_LABEL }}
				</label>
				<select data-testid="SUBSYS5_NOTIFICATION_THRESHOLD_SELECT" class="form-control custom-select"
					id="notification-threshold" style="width: 10rem;" [(ngModel)]="threshold"
					[ngModelOptions]="{standalone: true}" [disabled]="isReadonly()">
					<option [ngValue]="0">{{ labels().NOTIFICATION_THRESHOLD_COMPONENT_VALUE_NULL }}</option>
					@for (threshold of THRESHOLD_LIST; track $index) {
					<option [ngValue]="threshold">{{ threshold }}</option>
					}
				</select>
			</div>
		</form>
	</div>
	<div data-testid="SUBSYS5_NOTIFICATION_THRESHOLD_DESC_TXT" class="align-self-end ms-5">
		{{ labels().NOTIFICATION_THRESHOLD_COMPONENT_DESCRIPTION }}
	</div>
</div>